<template>
  <a role="button" class="small" @click.prevent="handleSelectAll">
    {{ isSelectedAll ? 'Unselect' : 'Select' }} all
  </a>
</template>

<script>
import { defineComponent, computed, inject } from '@vue/composition-api'

export default defineComponent({
  name: 'BaseCheckistAllToggle',
  setup() {
    const { modelValue, setModelValue, optionItems } = inject('base-checklist')

    const isSelectedAll = computed(
      () => modelValue.value.length === optionItems.value.length
    )

    const handleSelectAll = () => {
      if (isSelectedAll.value) setModelValue([])
      else {
        const newModelValue = optionItems.value.map((item) => {
          if ('string' === typeof item) return item
          else return item.value
        })

        setModelValue(newModelValue)
      }
    }

    return {
      isSelectedAll,
      handleSelectAll
    }
  }
})
</script>
